import { store } from './store';

export function authHeader() {
    const state = store.getState();

    if (state.authentication.token != null) {
        return "Authorization " + state.authentication.token;
    }
    else {
        return "";
    }
}


// WEBPACK FOOTER //
// ./src/_helpers/auth-header.js